import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

const KEY = "bs_currency";

export function CurrencyProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [currency, setCurrencyState] = useState(localStorage.getItem(KEY) || "INR");

  useEffect(() => {
    api.get("/commerce").then(({ data }) => {
      setConfig(data);
      if (!localStorage.getItem(KEY) && data.default_currency) {
        setCurrencyState(data.default_currency);
      }
    }).catch(() => {});
  }, []);

  const setCurrency = (c) => { localStorage.setItem(KEY, c); setCurrencyState(c); };
  const symbol = (config?.currencies || []).find((c) => c.code === currency)?.symbol || "";

  const price = (map) => {
    if (!map || Object.keys(map).length === 0) return null;
    const def = config?.default_currency || "INR";
    const val = map[currency] ?? map[def] ?? Object.values(map)[0];
    const approx = map[currency] === undefined;
    return { val, approx };
  };
  const fmt = (map) => {
    const p = price(map);
    if (p == null) return "Custom";
    return `${symbol}${Number(p.val).toLocaleString()}${p.approx ? "*" : ""}`;
  };
  const fmtNum = (n) => `${symbol}${Number(n || 0).toLocaleString()}`;

  return (
    <CurrencyContext.Provider value={{ config, currency, setCurrency, symbol, price, fmt, fmtNum }}>
      {children}
    </CurrencyContext.Provider>
  );
}
